import { jsx } from "react/jsx-runtime";
import { createContext, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { DISTINCT_ID_KEY, cookies, customLocalStorage, loadScript } from "@crehana/utils";
import { MeAuthContextDocument } from "./graphql/me.generated.js";
import useTalentUser from "./hooks/useTalentUser/useTalentUser.js";
import { getStudentType } from "./utils/index.js";
const AuthContext = /*#__PURE__*/ createContext(void 0);
const AuthProvider = ({ children, onLogout, meQueryOptions })=>{
    const { data, loading, error, refetch, updateQuery } = useQuery(MeAuthContextDocument, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
        ...meQueryOptions
    });
    const { talentUser } = useTalentUser({
        userEmail: data?.me?.email || '',
        organizationSlug: data?.me?.organization?.slug
    });
    useEffect(()=>{
        if (!loading && data) {
            if (data.me) {
                if (window.Sentry) window.Sentry.configureScope((scope)=>{
                    scope.setUser({
                        email: data.me.email,
                        id: data.me.originalId || void 0
                    });
                });
                const customData = {
                    segment: data.me.segmentationKey,
                    username: data.me.username
                };
                customLocalStorage.setItem('creh-tracking-data', JSON.stringify(customData));
            } else if (window.Sentry) window.Sentry.configureScope((scope)=>{
                scope.setUser({
                    email: null
                });
            });
        } else if (!loading && !data) loadScript({
            src: 'https://accounts.google.com/gsi/client',
            defer: true
        });
    }, [
        loading,
        data
    ]);
    const logout = ()=>{
        customLocalStorage.removeItem('creh-tracking-data');
        customLocalStorage.removeItem('user');
        customLocalStorage.removeItem('updates-admindashboard-popup-shown');
        cookies.deleteCookie(DISTINCT_ID_KEY);
        if (data?.me?.organization?.slug) {
            window.location.href = `/logout/?next=/org/${data?.me?.organization?.slug}/entrar/?next=${window.location.pathname}`;
            return;
        }
        if (onLogout) onLogout();
        else window.location.href = '/logout/';
    };
    return /*#__PURE__*/ jsx(AuthContext.Provider, {
        value: {
            data: {
                me: data?.me ? {
                    ...data.me,
                    ...getStudentType({
                        user: data.me
                    })
                } : null,
                loading,
                error,
                refetch,
                updateMe: updateQuery,
                talentUser
            },
            logout
        },
        children: children
    });
};
export { AuthContext, AuthProvider };
